import { useState } from "react";
import useListSubFormState, { ListSubFormState } from "./useListSubFormState";

export type ListModalState<T> = {
  open: boolean;
  index?: number;
  item?: T;
};

export type ListSubFormWithModalState<T> = ListSubFormState<T> & {
  modalState: ListModalState<T>;
  setModalState: (state: ListModalState<T>) => void;
  closeModal: () => void;
  submitModal: (req: T) => void;
};

export default function useListSubFormWithModalState<ItemType>(
  initialData?: ItemType[]
): ListSubFormWithModalState<ItemType> {
  const subFormState = useListSubFormState<ItemType>(initialData);

  const [modalState, setModalState] = useState<ListModalState<ItemType>>({
    open: false
  });
  const closeModal = () => {
    setModalState({ open: false, index: undefined, item: undefined });
  };
  const submitModal = (req: ItemType) => {
    if (modalState.index !== undefined) {
      subFormState.setItem(req, modalState.index);
    } else {
      subFormState.addItem(req);
    }
    closeModal();
  };

  return {
    ...subFormState,
    modalState,
    setModalState,
    closeModal,
    submitModal
  };
}
